/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gads_Refresh_TokenInputs */

const cs_integrations_gads_refresh_token = /** @type {(inputs: Integrations_Gads_Refresh_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh token`)
};

const en_integrations_gads_refresh_token = /** @type {(inputs: Integrations_Gads_Refresh_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh token`)
};

/**
* | output |
* | --- |
* | "Refresh token" |
*
* @param {Integrations_Gads_Refresh_TokenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gads_refresh_token = /** @type {((inputs?: Integrations_Gads_Refresh_TokenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gads_Refresh_TokenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gads_refresh_token(inputs)
	return cs_integrations_gads_refresh_token(inputs)
});